import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import '../styles/Footer.css'; // CSS-Import

const Footer = () => {
  return (
    <footer className="portfolio-footer">
      <div className="container">
        <div className="footer-content">
          <h3>Lassen Sie uns zusammen-arbeiten.</h3>
          <p>Ich bin immer offen für neue, spannende Projekte. Schreiben Sie mir eine Nachricht.</p>
          <div className="social-links">
            <a href="https://github.com/PMTobi" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/tobias-grimm-004009334/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="#kontakt" aria-label="E-Mail">
              <FaEnvelope />
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Tobias Grimm | <Link to="/impressum">Impressum</Link> | <Link to="/datenschutz">Datenschutz</Link></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;